import { Maatregel, MaatregelVergelijking, VsmVergelijking } from "@/entities/vsm";
import { createContext, useContext } from "react";
import { useMaatregelContext } from "./maatregel-context";

export type VsmVergelijkingContextType = {
    // Verdicts keyed by maatregel id.
    nieuw: Map<string, MaatregelVergelijking>;
    huidig: Map<string, MaatregelVergelijking>;
    isStatusGewijzigd: boolean;
};

// Without a provider, for instance in vsm-details or the regular VSM dialog, nothing is tagged.
export const vsmVergelijkingDefaults: VsmVergelijkingContextType = {
    ...VsmVergelijking.empty(),
    isStatusGewijzigd: false,
};

export const VsmVergelijkingContext = createContext<VsmVergelijkingContextType>(vsmVergelijkingDefaults);

// The verdict is taken from the versie the maatregel is rendered in: de huidige versie only reports
// Vervallen, de nieuwe versie reports Nieuw and Gewijzigd.
export function useMaatregelVergelijking(maatregel: Maatregel): MaatregelVergelijking {
    const { nieuw, huidig } = useContext(VsmVergelijkingContext);
    const { variant } = useMaatregelContext();

    if (variant === "view") {
        return VsmVergelijking.unchanged();
    }
    return VsmVergelijking.forMaatregel(variant === "oud" ? huidig : nieuw, maatregel);
}

export function useIsVsmStatusGewijzigd(): boolean {
    return useContext(VsmVergelijkingContext).isStatusGewijzigd;
}
